import React, { useState } from "react";
import { supabase } from './supabaseClient';
import { useNavigate } from "react-router-dom";

export default function RegisterPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [info, setInfo] = useState("");   // ✅ pour afficher message confirmation renvoyée
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setInfo("");
    setLoading(true);

    if (!email || !password) {
      setError("Merci de remplir tous les champs");
      setLoading(false);
      return;
    }

    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: window.location.origin + "/confirmation.html", // ✅ option utile
      },
    });

    setLoading(false);

    if (error) {
      setError(error.message || "Une erreur est survenue.");
      return;
    }

    setSuccess("✅ Compte créé ! Merci de valider l’email reçu avant de vous connecter.");
    setTimeout(() => {
      navigate("/");
    }, 3000);
  };

  // ✅ Renvoyer l’email de confirmation
  const handleResendConfirmation = async () => {
    if (!email) {
      setError("Renseignez d'abord votre email dans le champ.");
      return;
    }
    setError("");
    setSuccess("");
    setInfo("");

    const { error } = await supabase.auth.resend({
      type: "signup",
      email,
    });

    if (error) {
      setError("Erreur : " + error.message);
    } else {
      setInfo("📧 Un nouvel email de confirmation a été envoyé !");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex bg-white rounded-lg shadow-lg overflow-hidden w-full max-w-2xl">
        <div className="hidden md:block md:w-1/2 bg-gray-100">
          <img
            src="https://images.unsplash.com/photo-1567113463300-102a7eb3cb26?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0"
            alt="Dressing"
            className="object-cover w-full h-full"
          />
        </div>
        <div className="w-full md:w-1/2 flex flex-col justify-center p-8">
          <h2 className="text-3xl font-bold mb-3">Créer un compte</h2>
          <form className="space-y-4" onSubmit={handleRegister}>
            <input
              type="email"
              placeholder="Email"
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Mot de passe"
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && <div className="text-red-500">{error}</div>}
            {success && <div className="text-green-600">{success}</div>}
            {info && <div className="text-blue-600">{info}</div>}

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold transition"
              disabled={loading}
            >
              {loading ? "Création en cours..." : "Créer mon compte"}
            </button>
          </form>

          {/* ✅ Bouton renvoi confirmation */}
          <div className="mt-4 text-sm">
            <button
              type="button"
              onClick={handleResendConfirmation}
              className="text-blue-600 hover:underline bg-transparent border-none p-0"
            >
              Renvoyer l’email de confirmation
            </button>
          </div>

          <div className="mt-4 text-sm">
            <a href="/" className="text-blue-600 hover:underline">
              Déjà un compte ? Se connecter
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
